module.exports = __webpack_public_path__ + "media/images/arrow-icon-bf4e1424b47685873b9ea8a45c62f31ef46dc83aec1fbcb5078353fa575ec218.svg";